module.exports = __webpack_public_path__ + "static/img/materialsInfo1t1.1a97ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo1t1.png
// module id = kVHx
// module chunks = 2